import React, { Component } from "react";

export default class Badges extends Component {
  render() {
    return <div>there will be table here</div>;
  }
}
